import { render, staticRenderFns } from "./PricingTemplatesSection.vue?vue&type=template&id=fe267578&"
import script from "./PricingTemplatesSection.vue?vue&type=script&lang=js&"
export * from "./PricingTemplatesSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports